﻿package org.zq.pixelset.processing

import org.zq.pixelset.model.DecodedImage

object ThumbnailGenerator {
    private const val MAX_SIZE = 96

    fun createThumbnail(source: DecodedImage): DecodedImage {
        if (source.width <= MAX_SIZE && source.height <= MAX_SIZE) return source
        val scale = minOf(MAX_SIZE.toFloat() / source.width, MAX_SIZE.toFloat() / source.height)
        val w = (source.width * scale).toInt().coerceAtLeast(1)
        val h = (source.height * scale).toInt().coerceAtLeast(1)
        return ImageResize.scaleBilinear(source, w, h)
    }
}
